export const getCommercialProducts = state => state.getIn(['products', 'commercialproductsV2']).toJS();
